import { render, staticRenderFns } from "./CashOnHandList.vue?vue&type=template&id=8988df36"
import script from "./CashOnHandList.vue?vue&type=script&lang=js"
export * from "./CashOnHandList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports